export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '42.0.1',
    name: 'lingo2-web',
    versionDate: '2025-08-09T18:30:54.174Z',
    gitCommitHash: 'd2a85ac',
    versionLong: '42.0.1-d2a85ac',
};
export default versions;
